import {
  FaUniversity,
  FaDigitalTachograph,
  FaShieldAlt,
  FaPlaneDeparture,
  FaFileInvoiceDollar,
  FaHandHoldingUsd,
} from "react-icons/fa";



const services = [
  // {
  //   title: "Banking Services",
  //   desc: "No working capital required. Offer uninterrupted banking services like cash withdrawal, money transfer, cash deposits, savings, insurance and loan from your shop. ShreeBalaJee Connect Pvt. Ltd. (BINGOPAY), which means transacting on the platform is very secure and has a time tested success ratio of more than 99.9%.",
  //   icon: FaUniversity,
  // },
  // {
  //   title: "Digital Suite",
  //   desc: "Upgrade your business with ShreeBalaJee Connect Pvt. Ltd. (BINGOPAY) digital solutions.This service is free for all our partner retailers. ShreeBalaJee Connect Pvt. Ltd. (BINGOPAY) Digital Suite helps you scale your business by adopting the right digital tools — from multiple digital payment options to a digitized customer ledger to manage payments, reconciliation, and customer credits more efficiently.",
  //   icon: FaDigitalTachograph,
  // },
  {
    title: "Insurance",
    desc: "Less than 3% of Bharat is insured. Safeguard your customers from the uncertainties of life. Protect them with affordable insurance plans across health, medical and general insurance. Earn respect and money while you are at it",
    icon: FaShieldAlt,
  },
  {
    title: "Travel",
    desc: "Become the one-stop travel agency in your area An IATA approved travel service provider, we offer you the most comprehensive range of travel products and services at very affordable rates and great commissions. Offer rail, flights, hotels, holidays and more from your shop",
    icon: FaPlaneDeparture,
  },
  // {
  //   title: "Utility Bill Payment Centre",
  //   desc: "Ensure recurring monthly income Households need to pay their EMIs, subscriptions fees and utility bills every month. Solve customer pain point of standing in long queues. From water bills to electricity bills, from phone/DTH recharges to monthly EMIs, provide easy cash collection, bill payment and recharge solutions from your shop",
  //   icon: FaFileInvoiceDollar,
  // },
  // {
  //   title: "Credit Services",
  //   desc: "Tailored credit services for all Unlock growth opportunities with business loans. Access funds to expand, upgrade, or meet any business needs. Offer loans to your customers without any branch visit. Simplify loan processes, enabling convenience and fostering mutual profitability for your business and valued customers.",
  //   icon: FaHandHoldingUsd,
  // },
];

export default services;
